export default __webpack_public_path__ + "static/media/icon_number_yellow_3.3131d6e3.svg";